// Meta (Facebook) Pixel — landing + lead-capture conversion tracking.
// The Pixel ID is set in the ADMIN panel (Settings → Meta Pixel ID) and fetched at runtime, so it can
// be changed without a redeploy. REACT_APP_META_PIXEL_ID (build-time env) overrides it if set.
// Empty = no-op (nothing loads), safe to ship before an ID exists.
import axios from 'axios';

const ENV_ID = (process.env.REACT_APP_META_PIXEL_ID || '').trim();
const API_BASE = process.env.REACT_APP_API_URL || '/api';
let loaded = false;

const load = (pixelId) => {
  const id = String(pixelId || '').trim();
  if (!id || loaded || typeof window === 'undefined') return;
  loaded = true;
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', id);
  window.fbq('track', 'PageView');
};

// Init the pixel: env override first, else the admin-configured ID from the public endpoint.
export const initPixel = async () => {
  if (ENV_ID) return load(ENV_ID);
  try {
    const r = await axios.get(`${API_BASE}/public/tracking-config`);
    if (r.data && r.data.meta_pixel_id) load(r.data.meta_pixel_id);
  } catch (_) { /* no-op if unreachable */ }
};

// Track a standard event (e.g. 'Lead'). Pass eventId (from the server) so the browser + Conversions
// API events dedupe in Meta. No-op until the pixel is loaded.
export const trackPixel = (event, params = {}, eventId = null) => {
  if (typeof window === 'undefined' || !window.fbq) return;
  if (eventId) window.fbq('track', event, params, { eventID: eventId });
  else window.fbq('track', event, params);
};
